import React, { useMemo } from "react";
import { describeBuildWait } from "../modules/containerBuildProgress";
import useElapsedSeconds from "../customHooks/useElapsedSeconds";

/**
 * "Waiting for the build server — 2 builds ahead of you… (40s)": the current
 * step of a playEngine build, with a clock that shows the page is alive.
 * Renders nothing when there is no step to show. Styling is the caller's.
 */
export default function BuildWaitLine({ events, active = true, nameOf, stageLabels, className, style }) {
  const step = useMemo(
    () => (active ? describeBuildWait(events, { ...(nameOf ? { nameOf } : {}), stageLabels }) : null),
    [active, events, nameOf, stageLabels]
  );
  const seconds = useElapsedSeconds(step ? step.key : null);
  if (!step) return null;

  const text = `${step.label}… (${seconds}s)`;
  return (
    <span className={className} style={style} title={text}>
      {text}
    </span>
  );
}
